import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppNav } from 'src/routes/app-nav';
import { UserDTO } from 'src/classes/userDTO';
import { map, Observable, take, tap } from 'rxjs';
import { UserRepository } from 'src/state/user.repository';
import { HEADER_KEYS } from 'src/shared/constants';
import { API_BASE_URI } from 'src/shared/constants';

@Injectable({ providedIn: 'root' })
export class UserService {
  loggedInUser: UserDTO | undefined;
  AppNav = AppNav;

  constructor(private userRepo: UserRepository, private http: HttpClient) {}

  private _xsrfToken?: string;

  public get XsrfToken(): string {
    return this._xsrfToken!;
  }

  getLoggedInUser(): Observable<UserDTO | undefined> {
    return this.userRepo.getUser$();
  }

  clearLoggedInUser(): void {
    this.userRepo.clearUser();
  }

  private getUserInfo$(): Observable<UserDTO> {
    return this.http
      .get<UserDTO>(API_BASE_URI + '/api/auth/userinfo', {
        observe: 'response',
      })
      .pipe(
        tap((httpResponse) => {
          const xsrfReq = httpResponse.headers.get(
            HEADER_KEYS.xsrfRequestToken
          );
          if (!xsrfReq) {
            return;
          }
          this._xsrfToken = xsrfReq;
        }),
        map((httpResponse) => httpResponse.body!)
      );
  }

  initialize$(): Observable<UserDTO | null> {
    return this.getUserInfo$().pipe(
      take(1),
      tap((user: UserDTO) => this.userRepo.setUser(user))
    );
  }
}
